/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/slideorfade/slideorfade.ts" />
/// <reference path="../../common/forms/forms.ts" />
/// <reference path="../../common/common/common.ts" />

namespace OfficeGuy.CRM {
    export class PropertyPicker {
        static Init(): void {
            $(document.body)
                .on("change.schemapropertydetails_schemapicker", ".schemapropertydetails .schemapicker", function () {
                    PropertyPicker.GetPropertyBySchema(this);
                })
                .on("change.schemaviewpropertydetails_schemapicker", ".schemaviewpropertydetails .schemapicker", function () {
                    PropertyPicker.GetViewPropertyBySchema_View(this);
                })
                .on("change.schemaviewpropertydetails_viewpicker", ".schemaviewpropertydetails .viewpicker", function () {
                    PropertyPicker.GetViewPropertyBySchema_Property(this);
                });
        }
        static InitEditors(Container?: any): void {
            $("input.simplepropertypicker", Container).each(function () {
                var $Hidden = $(this);
                var Instance = Teva.SelectBox.GetInstance($Hidden);
                if (Instance != null)
                    return;

                $Hidden.attr("data-text", $Hidden.val() == "" ? "בחירת שדה" : $Hidden.data("propertyname"));

                Teva.SelectBox.Enable($Hidden, {
                    QueryMethod: function (Terms, QueryByID, PageIndex, Callback) {
                        var Data = {
                            more: false,
                            results: []
                        };

                        Common.AjaxRequest({
                            Method: 'GET',
                            URL: "/schema/propertypicker/?schemaid=" + $Hidden.data("schemaid") + "&singlelevel=true&includeincoming=" + ($Hidden.data("includeincoming") != false),
                            SuccessMethod: function (Response) {
                                for (var i = 0; i < Response.length; i++) {
                                    Data.results.push({
                                        id: Response[i].attr.PropertyID,
                                        text: Response[i].data
                                    });
                                }

                                Callback(Data);
                            },
                            ShowLoading: false
                        });
                    },
                    PlaceHolderText: "בחירת שדה",
                    Enabled: $Hidden.data("schemaid") != "0",
                    AllowClear: false,
                    OnChange: function (Value, Text, Data, Instance) {
                        if (Value == null || Value == "") {
                            console.log("Still needed...");
                            $Hidden.val("0");
                        }
                    },
                    EmptyValue: "0",
                    EmptyItemAlwaysVisible: true,
                    EmptyItemContents: $Hidden.data("disablecreatenew") == "1" ? null : function (Terms) {
                        var Text = "יצירת שדה";
                        if (Instance != null && Terms.length != 0)
                            Text += " '" + Terms + "'";
                        Text += ' <span class=\"icon-sumit-plus color-submit\"></span>';
                        return Text;
                    },
                    EmptyItemClick: $Hidden.data("disablecreatenew") == "1" ? null : function () {
                        Instance.ClearValue();
                        //OfficeGuy.CRM.Main.EntityMenu_Container = PickerContainer;
                        PropertyPicker.PopupCreateProperty(Instance, $Hidden.data("schemaid"), Instance.$SearchTermsInput.val());
                        return true;
                    },
                });
                Instance = Teva.SelectBox.GetInstance($Hidden);
            });

            $("input.viewpropertypicker", Container).each(function () {
                var $Hidden = $(this);
                var Instance = Teva.SelectBox.GetInstance($Hidden);
                if (Instance != null)
                    return;

                $Hidden.attr("data-text", $Hidden.val() == "" || $Hidden.val() == "0" ? "בחירת שדה" : $Hidden.data("propertyname"));

                Teva.SelectBox.Enable($Hidden, {
                    QueryMethod: function (Terms, QueryByID, PageIndex, Callback) {
                        var Data = {
                            more: false,
                            results: []
                        };

                        Common.AjaxRequest({
                            Method: 'GET',
                            URL: "/schema/propertypicker/?schemaid=" + $Hidden.data("schemaid") + "&viewid=" + $Hidden.data("viewid") + "&singlelevel=true&includeincoming=true",
                            SuccessMethod: function (Response) {
                                for (var i = 0; i < Response.length; i++) {
                                    Data.results.push({
                                        id: Response[i].attr.PropertyID,
                                        text: Response[i].data
                                    });
                                }

                                Callback(Data);
                            },
                            ShowLoading: false
                        });
                    },
                    PlaceHolderText: "בחירת שדה",
                    Enabled: $Hidden.data("schemaid") != "0" && $Hidden.data("schemaid") != "",
                    AllowClear: false,
                    OnChange: function (Value, Text, Data, Instance) {
                        if (Value == null || Value == "")
                            $Hidden.val("0");
                    }
                });
                Instance = Teva.SelectBox.GetInstance($Hidden)
            });
        }

        static PopupCreateProperty(Instance: any, SchemaID: any, Text: string = null): boolean {
            var URL = "/schema/createproperty/?schemaid=" + SchemaID + "&pickermodal=true";
            if (Text != null)
                URL += "&text=" + encodeURI(Text);
            var ConvertToAjax_PreRenderEvent = function (Data) {
                Notifications.Show(Data.Notifications);
                if (Data.PropertyID != null && Data.PropertyID != 0) {
                    Instance.SetValue(Data.PropertyID, Data.PropertyName);
                    Modals.Hide(Modal);
                    Instance.ClearCache();
                    return true;
                }
            };
            var Modal = OfficeGuy.Modals.ShowHTMLGetDialog({
                URL: URL,
                ConvertToAjax: true,
                ReplaceModal: true,
                ConvertToAjax_PreRenderEvent: ConvertToAjax_PreRenderEvent,
                HideEvent: function () {
                    Teva.Navigation.FocusOnFirstField(Instance.Container);
                }
            });
            return false;
        }

        static GetPropertyBySchema(Schema) {
            var SchemaID = $(Schema).val();
            var $PropertyPicker = $("input.simplepropertypicker", $(Schema).closest('.schemapropertydetails'));
            $PropertyPicker.data("schemaid", SchemaID);

            var PropertyPickerInstance = Teva.SelectBox.GetInstance($PropertyPicker);
            PropertyPickerInstance.ClearCache();
            PropertyPickerInstance.ClearValue();
            PropertyPickerInstance.Toggle(SchemaID != 0);
        }

        static GetViewPropertyBySchema_View(Schema) {
            var SchemaID = $(Schema).val();

            var $ViewPicker = $("input.viewpicker", $(Schema).closest('.schemaviewpropertydetails'))
                .data("schemaid", SchemaID);

            var $PropertyPicker = $("input.viewpropertypicker", $(Schema).closest('.schemaviewpropertydetails'))
                .data("schemaid", SchemaID)
                .data("viewid", 0);

            var ViewPickerInstance = Teva.SelectBox.GetInstance($ViewPicker);
            ViewPickerInstance.ClearCache();
            ViewPickerInstance.ClearValue();
            ViewPickerInstance.SetValue(0, "כל השדות");
            ViewPickerInstance.Toggle(SchemaID != 0);

            var PropertyPickerInstance = Teva.SelectBox.GetInstance($PropertyPicker);
            PropertyPickerInstance.ClearCache();
            PropertyPickerInstance.ClearValue();
            PropertyPickerInstance.Toggle(SchemaID != 0);
        }

        static GetViewPropertyBySchema_Property(View) {
            var ViewID = $(View).val();
            var $PropertyPicker = $("input.viewpropertypicker", $(View).closest('.schemaviewpropertydetails'));
            $PropertyPicker.data("viewid", ViewID);

            var PropertyPickerInstance = Teva.SelectBox.GetInstance($PropertyPicker);
            PropertyPickerInstance.ClearCache();
            PropertyPickerInstance.ClearValue();
        }

        static Load($Container, SchemaID, SingleLevel, Deleted, OnLoad = null, OnSelect = null, IncludeEntityName = false, IncludeEntities = true) {
            $Container = $(document.createElement('div'))
                .addClass("modal-buttonspanel")
                .appendTo($Container);

            $Container.addClass("modal-buttonspanel-loading");

            Common.AjaxRequest({
                Method: 'GET',
                URL: "/schema/propertypicker/?schemaid=" + SchemaID + "&singlelevel=" + (SingleLevel == null ? false : Deleted) + "&deleted=" + (Deleted == null ? false : Deleted) + "&includeentityname=" + (IncludeEntityName == null ? false : IncludeEntityName) + "&includeincoming=true",
                SuccessMethod: function (Data) {
                    $(Data).each(function () {
                        var DataItem = this;
                        if (DataItem.attr.ValueType == 'Entity' && !IncludeEntities)
                            return;

                        var $Icon = $(document.createElement('span'))
                            .addClass("menu-icon");

                        switch (DataItem.attr.ValueType) {
                            case "ShortText":
                                if (DataItem.attr.StringFormat == "EmailAddress" || DataItem.attr.StringFormat == "EmailAddresses")
                                    $Icon.addClass("icon-sumit-field-email");
                                else if (DataItem.attr.StringFormat == "PhoneNumber" || DataItem.attr.StringFormat == "PhoneNumbers" || DataItem.attr.StringFormat == "IsraelPhoneNumber")
                                    $Icon.addClass("icon-sumit-field-phone");
                                else
                                    $Icon.addClass("icon-sumit-field-text");
                                break;
                            case "LongText":
                            case "RichText":
                            case "Enum":
                            case "EnumFlags":
                            case "EnumLabel":
                                $Icon.addClass("icon-sumit-field-text");
                                break;
                            case "Date":
                            case "DateTime":
                            case "Time":
                            case "Month":
                            case "DateWithoutYear":
                                $Icon.addClass("icon-sumit-field-date");
                                break;
                            case "Int64":
                            case "Decimal":
                                $Icon.addClass("icon-sumit-field-hash");
                                break;
                            case "Boolean":
                                $Icon.addClass("icon-sumit-field-boolean");
                                break;
                            case "File":
                                $Icon.addClass("icon-sumit-field-file");
                                break;
                            case "Schema":
                                $Icon.addClass("icon-sumit-folder");
                                break;
                            case "Hyperlink":
                                $Icon.addClass("icon-sumit-link");
                                break;
                            case "SchemaView":
                                $Icon.addClass("icon-grid");
                                break;
                            case "SchemaProperty":
                            case "SchemaViewProperty":
                                $Icon.addClass("icon-add-field");
                                break;
                            case "Entity":
                                if (DataItem.state == "closed")
                                    $Icon.addClass("icon-sumit-field-plus");
                                else
                                    $Icon.addClass("icon-doc");
                                break;
                            case "NavigationAddress":
                                $Icon.addClass("icon-sumit-field-location");
                                break;
                            case null:
                                if (DataItem.attr.PropertyID == 0)
                                    $Icon.addClass("icon-sumit-field-text");
                                break;
                        };

                        var $Item = $(document.createElement('a'))
                            .text(DataItem.data)
                            .addClass("modal-buttonspanel-item")
                            .data("dataitem", DataItem)
                            .addClass(DataItem.attr.cssClass)
                            .appendTo($Container);

                        $Icon.prependTo($Item);

                        if (OnSelect != null) {
                            $Item.attr("href", "#")
                                .on("click", function () {
                                    OnSelect(DataItem, $Item);
                                    return false;
                                })
                        }

                        if (DataItem.state == "closed") {
                            $Icon.on("click", function () {
                                if ($Icon.hasClass("icon-sumit-field-minus")) {
                                    Teva.SlideOrFade.Hide($("> .modal-buttonspanel", $Item), 200);
                                    $Icon.removeClass("icon-sumit-field-minus").addClass("icon-sumit-field-plus");
                                }
                                else if ($("> .modal-buttonspanel", $Item).length > 0) {
                                    Teva.SlideOrFade.Show($("> .modal-buttonspanel", $Item), 200);
                                    $Icon.removeClass("icon-sumit-field-plus").addClass("icon-sumit-field-minus");
                                }
                                else {
                                    PropertyPicker.Load($Item, DataItem.attr.ValueSchemaID, SingleLevel, Deleted, function () {
                                        $Icon.removeClass("icon-sumit-field-plus").addClass("icon-sumit-field-minus");
                                    }, OnSelect);
                                }
                                return false;
                            });
                        }
                    });
                    $Container
                        .removeClass("modal-buttonspanel-loading")
                        .hide();
                    $Container.slideToggle(200);
                    Teva.Navigation.FocusOnFirstField($Container);
                    if (OnLoad != null)
                        OnLoad();
                },
                ShowLoading: false
            });
        }

        static ShowPropertyPicker(RootSchemaID, SuccessCallback, DisableAutoClose = false, SingleLevel = false, Deleted = false, IncludeEntityName = false, IncludeEntities = true, Title = null) {
            var $Modal = OfficeGuy.Modals.Create({
                Title: Title == null ? OfficeGuy.Resources.GetString("CRM", "ChooseField") : Title,
                Body: function (BodyContainer) {
                    var $TreeDiv = $(document.createElement('div'))
                        .appendTo(BodyContainer);
                    PropertyPicker.Load($TreeDiv, RootSchemaID, SingleLevel, Deleted, null, function (DataItem, Item) {
                        var Path = "";
                        var PathNames = "";
                        Item.parents(".modal-buttonspanel-item").each(function () {
                            var InnerDataItem = $(this).data("dataitem");
                            if (InnerDataItem.attr.PropertyID != "0") {
                                Path = InnerDataItem.attr.PropertyID + "." + Path;
                                if (InnerDataItem.attr.PropertyID < 0 || InnerDataItem.attr.PropertyID[0] == '-')
                                    PathNames = "-" + InnerDataItem.data + "." + PathNames;
                                else
                                    PathNames = InnerDataItem.data + "." + PathNames;
                            }
                        });
                        Path += DataItem.attr.PropertyID;
                        var Name = DataItem.data;
                        if (DataItem.attr.PropertyID < 0 || DataItem.attr.PropertyID[0] == '-')
                            PathNames += "-" + Name;
                        else
                            PathNames += Name;
                        SuccessCallback(Path, Name, PathNames, DataItem.attr.ValueType);
                        if (!DisableAutoClose)
                            OfficeGuy.Modals.Hide($Modal);
                    }, IncludeEntityName, IncludeEntities);
                }
            });
            return $Modal;
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.CRM.PropertyPicker.Init();
});
$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.CRM.PropertyPicker.InitEditors(Container);
});